__turbopack_context__.v({
  "className": "robotofont_143be493-module__pVNcVq__className",
  "variable": "robotofont_143be493-module__pVNcVq__variable",
});
